import React, {Component} from 'react'
import {Container, Row, Col, Button} from 'reactstrap'
import moment from 'moment'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import OfficeHoursWorkedTable from "./OfficeHoursWorkedTable"
import AUSelectGenerator from '../auto_updaters/Select'

const AUSelectOffices = AUSelectGenerator('offices', 'id description', 'id', ['description'])

export default class OfficeHoursReport extends Component {

    state = {
        office_id: 0
    }

    getMonthYearSetup = () => {
        const month = (this.props.match.params.month) ? this.props.match.params.month : moment().format('MM')
        const year = (this.props.match.params.year) ? this.props.match.params.year : moment().format('YYYY')
        const office_id = this.props.match.params.office_id || this.state.office_id
        const data = {
            month,
            year,
            date: moment(`${year}-${month}-01`).format('MMMM YYYY'),
            next: moment(`${year}-${month}-01`).add(1, 'month').format('YYYY-MM-DD'),
            last: moment(`${year}-${month}-01`).subtract(1, 'month').format('YYYY-MM-DD'),
            office_id
        }

        return data
    }

    render() {

        const {
            month,
            year,
            date,
            next,
            last,
            office_id
        } = this.getMonthYearSetup()

        return (

            <Container fluid>
                <div className="mt-3 mb-3 d-flex flex-row align-items-end justify-content-between">
                        <Button
                            size="sm"
                            color="primary"
                            onClick={() => this.props.history.push(`/reports/hours_worked/${office_id}/${moment(last).format('MM')}/${moment(last).format('YYYY')}`)}>
                            <FontAwesomeIcon
                                icon="chevron-left"
                            />{' '}
                            {moment(last).format('MMMM YYYY')}

                        </Button>
                    <div className="d-flex flex-column align-items-center">
                        <h4>{date}</h4>
                        <AUSelectOffices
                            size="sm"
                            defaultLabel="All Offices"
                            value={office_id}
                            onChange={(office_id) => this.props.history.push(`/reports/hours_worked/${office_id || 0}/${moment(date).format('MM')}/${moment(date).format('YYYY')}`)}/>
                    </div>
                        <Button
                            size="sm"
                            color="primary"
                            className="float-right"
                            onClick={() => this.props.history.push(`/reports/hours_worked/${office_id}/${moment(next).format('MM')}/${moment(next).format('YYYY')}`)}>
                            <FontAwesomeIcon
                                icon="chevron-right"
                            />{' '}
                            {moment(next).format('MMMM YYYY')}
                        </Button>
                </div>
                <Row>
                    <Col>
                        <OfficeHoursWorkedTable office_id={(office_id) ? office_id : null} month={month} year={year}/>
                    </Col>
                </Row>
            </Container>


        )

    }

}